interface SectionDividerProps {
  variant?: 'wave' | 'curve' | 'angle';
  flip?: boolean;
  className?: string;
  fillClassName?: string;
}

export const SectionDivider = ({
  variant = 'wave',
  flip = false,
  className = '',
  fillClassName = 'fill-background',
}: SectionDividerProps) => {
  const transforms = flip ? 'rotate-180' : '';

  const paths = {
    wave: 'M0,96L48,112C96,128,192,160,288,165.3C384,171,480,149,576,128C672,107,768,85,864,90.7C960,96,1056,128,1152,138.7C1248,149,1344,139,1392,133.3L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z',
    curve: 'M0,160L80,176C160,192,320,224,480,218.7C640,213,800,171,960,165.3C1120,160,1280,192,1360,208L1440,224L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z',
    angle: 'M0,256L1440,96L1440,320L0,320Z',
  };

  return (
    <div className={`w-full overflow-hidden leading-none ${className}`}>
      <svg
        className={`relative block w-full h-16 md:h-24 ${transforms}`}
        viewBox="0 0 1440 320"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d={paths[variant]}
          className={fillClassName}
        />
      </svg>
    </div>
  );
};
